module.exports = __webpack_public_path__ + "img/2.b928e1a1.jpeg";